import { call, put, takeLatest } from 'redux-saga/effects';
import { setNews } from './actions';
import { getNews } from './api';
import { FETCH_NEWS_REQUEST } from './constants';

function* fetchNews(param: any) {
	const response: object = yield call(getNews);
	yield put(setNews(response));
}

export function* sagaWatcher() {
	yield takeLatest(FETCH_NEWS_REQUEST, fetchNews);
}

const gens = [sagaWatcher()];
export default gens;
